import type { TeacherCohortAssignmentRecord } from "../auth/api-client";

export type AssignmentLifecycleLabel = "Planned" | "Assigned" | "Closed";

export function assignmentLifecycleLabel(a: TeacherCohortAssignmentRecord): AssignmentLifecycleLabel {
  if (a.closed) return "Closed";
  if (a.released) return "Assigned";
  return "Planned";
}
